import React from 'react'
import { TablaMisAgentes } from '../../Components/Components'

export const MisAgentes = ({initState,updateState,data,setData,load,reload}) => {
  return (
    <React.Fragment>
      <TablaMisAgentes initState={initState} updateState={updateState} data={data} setData={setData} load={load} reload={reload} />
    </React.Fragment>
  )
}